// extracted by mini-css-extract-plugin
export default {"menu":"AdminMenu_menu__7F5yu","menuLink":"AdminMenu_menuLink__1vYEW"};